// extracted by mini-css-extract-plugin
export default {"imagesWrapper":"YE-z"};